import {
  getGoldSetQueueUrl,
  type GoldSetDocument,
  GoldSetProgress,
  type GoldSetQueue,
  GoldSetStatusChip,
} from '~/entities/gold-set'
import { Button, SkeletonBlock, Text } from '~/shared/ui'

export function ReviewHeader({
  pass,
  documentKey,
  document,
  queue,
  isQueueError,
}: {
  pass: number
  documentKey: string
  document: GoldSetDocument | undefined
  queue: GoldSetQueue | undefined
  isQueueError: boolean
}) {
  return (
    <header className="border-divider flex shrink-0 flex-wrap items-center justify-between gap-x-6 gap-y-2 border-b py-2 pr-6 pl-2">
      <div className="flex items-center gap-3">
        <Button
          materialIcon="arrow_back"
          to={getGoldSetQueueUrl(pass)}
        >
          Queue
        </Button>
        <div className="flex flex-col">
          <Text appearance="SUBTITLE">{`Gold set, pass ${pass}`}</Text>
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            {document ? `Position ${document.position} · ${documentKey}` : documentKey}
          </Text>
        </div>
        {document && <GoldSetStatusChip status={document.status} />}
      </div>
      {queue ? (
        <GoldSetProgress queue={queue} />
      ) : isQueueError ? (
        <Text
          className="text-error-main"
          appearance="BODY2"
        >
          Could not load the queue: progress and next/previous are unavailable.
        </Text>
      ) : (
        <SkeletonBlock className="h-9 w-[220px]" />
      )}
    </header>
  )
}
